import { parseToDate } from './utils';

import type { Activity } from '../types/models/Activity';

type PreenrollmentWindow = Pick<
    Activity,
    'preenrollmentAllowed' | 'preenrollmentIni' | 'preenrollmentEnd'
>;

/**
 * Whether the renewal pre-enrollment window of an activity is open at `now`.
 * The same rule the API applies: armed, both dates set, both ends included.
 */
export function isPreenrollmentWindowOpen(
    activity: PreenrollmentWindow | null | undefined,
    now: Date,
): boolean {
    if (!activity?.preenrollmentAllowed) {
        return false;
    }

    const ini = parseToDate(activity.preenrollmentIni);
    const end = parseToDate(activity.preenrollmentEnd);

    if (!ini || !end) {
        return false;
    }

    return now >= ini && now <= end;
}
